import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { PaginationControlsComponent } from 'ngx-pagination';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';

import { CreateNewSurveyComponent } from './create-new-survey/create-new-survey.component';
import { ListPollsSurveyComponent } from './list-polls-survey/list-polls-survey.component';
import { DetailsPollsSurveyComponent } from './details-polls-survey/details-polls-survey.component';
import { UpdatePollsSurveyComponent } from './update-polls-survey/update-polls-survey.component';
import { UpdateSurveyQuestionComponent } from './update-survey-question/update-survey-question.component';
import { DetailsPollsSurveyTemplateComponent } from './details-polls-survey-template/details-polls-survey-template.component';
import { UpdateSurveyQuestionTemplateComponent } from './update-survey-question-template/update-survey-question-template.component';
import { SurveyReportComponent } from './survey-report/survey-report.component';

const routes: Routes = [
  { path: '', component: CreateNewSurveyComponent },
  { path: 'create-survey', component: CreateNewSurveyComponent },
  { path: 'list-survey', component: ListPollsSurveyComponent },
  { path: 'survey-details/:id', component: DetailsPollsSurveyComponent },
  { path: 'update-survey/:id', component: UpdatePollsSurveyComponent },
  { path: 'update-survey-question/:id', component: UpdateSurveyQuestionComponent },
  { path: 'survey-details-template/:id', component: DetailsPollsSurveyTemplateComponent },
  { path: 'update-survey-question-template/:id', component: UpdateSurveyQuestionTemplateComponent },
  { path: 'survey-report/:id', component: SurveyReportComponent },
];


@NgModule({
  declarations: [
    CreateNewSurveyComponent,
    ListPollsSurveyComponent,
    DetailsPollsSurveyComponent,
    UpdatePollsSurveyComponent,
    UpdateSurveyQuestionComponent,
    DetailsPollsSurveyTemplateComponent,
    UpdateSurveyQuestionTemplateComponent,
    SurveyReportComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot(),
    AutocompleteLibModule,
    NgSelectModule,
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SurveypollsModule { }
